<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg viewBox="0 0 24 24" {...rest} width={size * 4} height={size * 4} class={className}>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M12 7C11.45 7 11 7.45 11 8V11H8C7.45 11 7 11.45 7 12C7 12.55 7.45 13 8 13H11V16C11 16.55 11.45 17 12 17C12.55 17 13 16.55 13 16V13H16C16.55 13 17 12.55 17 12C17 11.45 16.55 11 16 11H13V8C13 7.45 12.55 7 12 7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
    fill="currentColor"
  />
</svg>
